function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "dollar_svg__cls-1",
  d: "M6.09 16.81v1.86a.34.34 0 01-.34.34H4.32a.34.34 0 01-.34-.34v-1.86a6.72 6.72 0 01-3.89-1.9.35.35 0 010-.44l1.09-1.43a.35.35 0 01.24-.13.29.29 0 01.25.1 5.56 5.56 0 003.38 1.43 1.92 1.92 0 002.16-1.75c0-1-1.25-1.52-2.68-2.09C2.62 9.85.24 8.89.24 6.23a4.24 4.24 0 013.74-4V.34A.34.34 0 014.32 0h1.43a.34.34 0 01.34.34v1.87a5.75 5.75 0 013.34 1.45.34.34 0 01.05.4l-.86 1.55a.31.31 0 01-.24.17.35.35 0 01-.29-.07 4.88 4.88 0 00-2.88-1.15c-1.35 0-2.28.67-2.28 1.63 0 1.12 1.29 1.62 2.8 2.21 2 .75 4.16 1.61 4.16 4.17a4.3 4.3 0 01-3.8 4.24z"
});

var SvgDollar = function SvgDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 9.88 19"
  }, props), _ref);
};

export default SvgDollar;